export default __webpack_public_path__ + "static/media/iphone-notificacion.343869f4.mp3";